import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

export function SessionTimeoutDialog({ open, seconds, onStay, onLogout }) {
  const [left, setLeft] = useState(seconds || 0);

  useEffect(() => { setLeft(seconds || 0); }, [seconds, open]);
  useEffect(() => {
    if (!open) return undefined;
    const id = setInterval(() => setLeft((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, [open]);

  const mm = Math.floor(left / 60);
  const ss = String(left % 60).padStart(2, "0");

  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="session-timeout-dialog" className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-fundio-gold" /> Sitzung läuft bald ab
          </AlertDialogTitle>
          <AlertDialogDescription>
            Sie waren eine Weile inaktiv. Aus Sicherheitsgründen werden Sie in{" "}
            <span data-testid="session-countdown" className="font-semibold text-fundio-ink">
              {mm}:{ss}
            </span>{" "}
            automatisch abgemeldet. Möchten Sie angemeldet bleiben?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button data-testid="session-logout-now" variant="outline" onClick={onLogout}>
            Jetzt abmelden
          </Button>
          <Button data-testid="session-stay-logged-in" onClick={onStay}>
            Angemeldet bleiben
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
